import * as yup from "yup";

export const existingProviderValidationSchema = yup.object().shape({
  selectedProvider: yup.object().nullable(),
  providerContactDetails: yup.object().nullable(),
  locationType: yup
    .string()
    .oneOf(
      ["primary", "secondary", "other"],
      "You must select a location type."
    )
    .required("This field is required"),
  primaryLocationTextBox: yup.string(),
  secondaryLocationTextBox: yup.string(),
  otheryLocationTextBox: yup.string(),
  secondaryAddress: yup.string().notRequired(),
  // Sync from UI: when user selects "new-location", this is "new-location"
  selectedAssessmentLocationId: yup.string().optional(),
  // Primary location (LocationFields) required only when "new-location" is selected
  primaryAddress: yup
    .string()
    .when("selectedAssessmentLocationId", {
      is: "new-location",
      then: (schema) => schema.required("Street address is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
  primaryCity: yup
    .string()
    .when("selectedAssessmentLocationId", {
      is: "new-location",
      then: (schema) => schema.required("City is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
  primaryState: yup
    .string()
    .when("selectedAssessmentLocationId", {
      is: "new-location",
      then: (schema) => schema.required("State/Province is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
  primaryCountry: yup
    .string()
    .when("selectedAssessmentLocationId", {
      is: "new-location",
      then: (schema) => schema.required("Country is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
  serviceCategories: yup
    .array()
    .min(1, "Please select at least one service category.")
    .required(),
  draftDate: yup
    .object({
      startDate: yup
        .date()
        .required("Desired Initial Draft Date is required")
        .test(
          "is-valid-date",
          "Start date must be a valid date",
          (value) => !isNaN(new Date(value).getTime())
        ),
    })
    .required("Draft date is required"),
  additionalDetails: yup.string().notRequired(),
  multiSponsor: yup.boolean().notRequired(),
  providerName: yup.string(),
  mainContactName: yup.string(),
  mainContactEmail: yup.string().email(),
  country: yup.object().nullable(),
  providerUrl: yup.string(),
  streetAddress: yup.string(),
  city: yup.string(),
  state: yup.string(),
  zipCode: yup.string(),
  additionalAddress: yup.string(),
  onsiteRemote: yup
    .object()
    .shape({
      onsite: yup.boolean().required("Onsite is required."),
      remote: yup.boolean().required("Remote is required."),
    })
    .test(
      "only-one-true",
      "Only one option (onsite or remote) must be selected.",
      (value) => {
        const values = Object.values(value || {});
        return values.filter((v) => v === true).length === 1;
      }
    )
    .required("This field is required"),
});
